let inject = ['$q','$http', 'ngAuthSettings', 'AuthTokenFactory', 'SharedService', 'SessionService', '$httpParamSerializerJQLike'];
class OrderDetailService {
  constructor ($q, $http, ngAuthSettings, AuthTokenFactory, SharedService, SessionService, $httpParamSerializerJQLike) {
    this.$q = $q;
    this.$http = $http;
    this.ngAuthSettings = ngAuthSettings;
    this.AuthTokenFactory = AuthTokenFactory;
    this.SharedService = SharedService;
    this.$httpParamSerializerJQLike = $httpParamSerializerJQLike;
    this.SessionService = SessionService;
  }

  changeStatus(data) {
    return this.$q((resolve, reject) => {
      this.$http({
        method: 'POST',
        url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.changeStatus,
        cache : false,
        data : this.$httpParamSerializerJQLike(data),
        headers: {'Content-Type': 'application/x-www-form-urlencoded'}
      }).then(response => {
        resolve(response.data);
      }).catch(reason => {
        reject(reason);
      });
    });
  }

  getOrderById(data) {
    return this.$q((resolve, reject) => {
      this.$http({
        method: 'POST',
        url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.getOrder,
        cache : false,
        data : this.$httpParamSerializerJQLike(data),
        headers: {'Content-Type': 'application/x-www-form-urlencoded'}
      }).then(response => {
        resolve(response.data);
      }).catch(reason => {
        reject(reason);
      });
    });
  }

  duplicateOrderById(userId, sellerId, orderId) {
    return this.$q((resolve, reject) => {
      this.$http({
        method: 'POST',
        url: this.ngAuthSettings.apiServiceBaseUri + '/cart/duplicate-order',
        cache : false,
        data : {'userId': userId, 'sellerId': sellerId, 'orderId': orderId}
      }).then(response => {
        resolve(response.data);
      }).catch(reason => {
        reject(reason);
      });
    });
  }

  syncOrder(data) {
    return this.$q((resolve, reject) => {
      this.$http({
        method: 'POST',
        url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.sincronizarPedido,
        data: this.$httpParamSerializerJQLike(data),
        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        cache : false
      }).then(function (response) {
        resolve(response.data);
      }, function (reason) {
        reject(reason);
      });
    });
  }

  saveSaveComment(data) {
  
    return this.$q((resolve, reject) => {
      this.$http({
        method: 'POST',
        url: this.ngAuthSettings.apiServiceBaseUri + "/order/save-comment",
        cache : false,
        data : data,
        headers: {'Content-Type': 'application/x-www-form-urlencoded'}
      }).then(response => {
        resolve(response.data);
      }).catch(reason => {
        reject(reason);
      });
    });
  }


}

OrderDetailService.$inject = inject;

export default OrderDetailService;



/** WEBPACK FOOTER **
 ** ./www/components/orders/order-detail/order-detail.service.js
 **/